import { ActionChip, useOverlay } from '@fs/zion-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import MakeDeadPersonDialogOverlay from './MakeDeadPersonDialogOverlay'

export default function MakeDeadActionChip() {
  const { t } = useTranslation()
  const overlay = useOverlay()

  return (
    <>
      <span style={{ display: 'inline-block' }}>
        <ActionChip label={t('person.status.makeDead', 'Make Dead')} onClick={overlay.handleClick} selected />
      </span>
      <MakeDeadPersonDialogOverlay {...overlay} />
    </>
  )
}
